export enum ShortcutKeyMap {
  KeyA = "KeyA",
  KeyI = "KeyI",
  KeyC = "KeyC",
  KeyR = "KeyR",
  KeyH = "KeyH",
  KeyN = "KeyN",
  KeyT = "KeyT",
  KeyW = "KeyW",
  KeyU = "KeyU",
  KeyG = "KeyG",
  KeyEsc = "Escape",
}
